import { BaseAPI } from '../BaseApi';
import { UUID } from '../../types/shared/UUID';
import { eAPITags } from '../eAPITags';
import { ICreateMobilityGroupRequest } from '../../types/mobility/ICreateMobilityGroupRequest';
import {
  convertToEditMobilityGroupRequest,
  IEditMobilityGroup,
  IMobilityGroup,
  IMobilityGroupWithOrders,
  IProgramTypeData,
  MobilityTransactionTypeData,
} from '../../types/mobility/IMobilityGroup';
import { cleanupRequestWithNulls } from '../cleanupRequests';

export const MobilityGroupApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listMobilityGroups: build.query<IMobilityGroup[], UUID>({
      query: (clientId) => `/timber/api/internal/mobility-groups?clientId=${clientId}`,
      providesTags: (response, error, clientId) => [
        {
          type: eAPITags.MobilityGroupData,
          clientId: clientId,
        },
        { type: eAPITags.MobilityGroupData },
      ],
    }),
    getMobilityGroupById: build.query<IMobilityGroupWithOrders, UUID>({
      query: (mobilityGroupdId) => `/timber/api/internal/mobility-groups/${mobilityGroupdId}`,
      providesTags: (response, error, mobilityGroupdId) => [
        {
          type: eAPITags.MobilityGroupData,
          id: mobilityGroupdId,
        },
      ],
    }),
    patchMobilityGroup: build.mutation<void, IEditMobilityGroup>({
      query: (request) => ({
        url: `/timber/api/internal/mobility-groups/${request.id}`,
        method: 'PATCH',
        body: cleanupRequestWithNulls(convertToEditMobilityGroupRequest(request)),
      }),
      invalidatesTags: (result, error, request) => [
        {
          type: eAPITags.MobilityGroupData,
          id: request.id,
        },
        { type: eAPITags.MobilityGroupData },
      ],
    }),
    createMobilityGroup: build.mutation<IMobilityGroup, ICreateMobilityGroupRequest>({
      query: (request) => ({
        url: `/timber/api/internal/mobility-groups`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: (result, error, { clientId }) => [{ type: eAPITags.MobilityGroupData, id: clientId }],
    }),
    listTransactionTypes: build.query<MobilityTransactionTypeData[], void>({
      query: () => `/timber/api/internal/mobility-transaction-types`,
    }),
    listProgramTypes: build.query<IProgramTypeData[], void>({
      query: () => `/timber/api/internal/program-types`,
    }),
  }),
});

export const {
  useListMobilityGroupsQuery,
  useCreateMobilityGroupMutation,
  useListTransactionTypesQuery,
  useListProgramTypesQuery,
} = MobilityGroupApi;
